import { signIn } from "next-auth/react";
import { useState, useEffect } from "react";
import Loader from "@components/atoms/Loader";
import { useAppDispatch } from "@stores/store";
import { socialLogin, getSession, forceLogin } from "@stores/slices/userSlice";
import {
  isWebview,
  clickLoginButtonNative,
  receiveTokenLoginNative,
  isWebViewAndroid,
} from "@utils/webview.util";

const SocialLoginProviders = ({ providers }: any) => {
  const providersList = providers.providers;
  const [position, setPosition] = useState(0);
  const [isDisabled, setisDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const isAndroid = isWebViewAndroid();

  const dispatch = useAppDispatch();
  const loginFromNative = async (email: string) => {
    const inputs = {
      email,
      name: "",
      provider: "",
    };
    await dispatch(socialLogin(inputs));
    const { payload } = await dispatch(getSession());
    if (payload.token) {
      receiveTokenLoginNative(payload.token);
    }
  };

  useEffect(() => {
    window.receiveEmailForLogin = (type: string, email: string) => {
      loginFromNative(email);
    };
  }, []);

  const handleSocialLogin = (providerId: string, itemIndex: number) => {
    if (isWebview()) {
      if (providerId === "google") {
        clickLoginButtonNative("google");
      }
      if (providerId === "apple") {
        clickLoginButtonNative("apple");
      }
    } else {
      signIn(providerId, {
        callbackUrl: "/",
      });
      setisDisabled(true);
      setPosition(itemIndex);
    }
  };

  return (
    <>
      {providersList && (
        <div className="row">
          <div className="col-12 position-relative text-center">
            <hr className="my-4" />
            <span className="text-or">{"หรือเข้าสู่ระบบด้วย"}</span>
          </div>
          {isLoading ? (
            <Loader heightPixel={"30"} />
          ) : (
            <>
              {Object.values(providersList).map((provider: any, idx) => {
                return (
                  <div key={provider.id} className="col-12 pe-1 mb-3">
                    <div className="d-grid">
                      <button
                        disabled={idx === position ? isDisabled : false}
                        className={`btn btn-outline-secondary text-center  ${
                          isAndroid && provider.id === "apple"
                            ? "d-none"
                            : "d-block"
                        }`}
                        onClick={() => handleSocialLogin(provider.id, idx)}
                      >
                        <i
                          className={`icon icon-${provider.id}-login me-3`}
                        ></i>
                        เข้าสู่ระบบด้วยบัญชี {provider.name}
                      </button>
                    </div>
                  </div>
                );
              })}
            </>
          )}
        </div>
      )}
    </>
  );
};

export default SocialLoginProviders;
